module.exports = __webpack_public_path__ + "static/media/medical-accountants.6d5a97c3.png";